import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Alert, Badge, Table } from "react-bootstrap";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import FilingPreview from "../FilingPreview/FilingPreview";
import moment from "moment";
import { orderBy } from 'lodash';
import "./FilingList.scss";
import {abbrivateCategories} from "../../../utils/StringUtils";

class FilingList extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      sortable: props?.sortable || false,
      filings: props?.filings || [],
      sortColumnMapping: {
        Company: { column: 'companyNameLong', direction: 'desc' },
        'Fetched At': { column: 'fetchedAtDate', direction: 'desc' },
        'Filed At': { column: 'filedAt', direction: 'desc' },
      },
      sortBy: '',
      sortSelection: {},
    };
  }

  componentDidMount(){
    this.setState({ filings: this.props?.filings || [], });
  }

  updateStateData(){
    this.setState({ filings: this.props?.filings || [], });
  }

  showDocument(filing, doc) {
    this.setState({ preview: { filing: filing, doc: doc } });
  }

  hideDocument() {
    this.setState({ preview: null });
  }

  handleSortBy = (title) => {
    let { sortColumnMapping, sortSelection } = this.state;
    sortColumnMapping = {
      ...sortColumnMapping,
      [title]: {
        ...sortColumnMapping[title],
        direction: sortColumnMapping[title].direction === 'asc' ? 'desc' : 'asc'
      },
    }
    sortSelection = {
      ...sortSelection,
      [title]: sortColumnMapping[title],
    }
    this.setState({
      sortColumnMapping: sortColumnMapping,
      sortBy: title,
      sortSelection: sortSelection,
    }, () => {
      this.sortData();
    });
  }

  Heading = ({
    title,
    classes = '',
  }) => {
    const { sortSelection, sortBy } = this.state;
    const direction = sortSelection[title]?.direction;
    const iconAsc = "south";
    const iconAscClass = sortBy === title && direction && (direction === "asc" ? "active" : "");
    const iconDesc = "north";
    const iconDescClass = sortBy === title && direction && (direction === "desc" ? "active" : "");
    return (
      <th
        className={classes}
        role={'button'}
        onClick={() => this.handleSortBy(title)}
      >
        {title}
        <span className={`material-icons sort ${iconAscClass}`}>{iconAsc}</span>
        <span className={`material-icons sort ${iconDescClass}`}>{iconDesc}</span>
      </th>);
  }

  sortData = () => {
    if (this.state.sortBy !== '') {
      const { sortColumnMapping, filings } = this.state;
      const column = sortColumnMapping[this.state.sortBy].column
      const direction = sortColumnMapping[this.state.sortBy].direction
      this.setState({
        filings: orderBy(filings, column, direction)
      });
    }
  }

  render() {
    const { preview, isLoading, error, sortable, filings } = this.state;
    const { catalogue, selections, queryByFetch, filtersVisibility  } = this.props;
    const { Heading } = this;
    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    return (
      <Fragment>
        {filings.length ? (
          <Table id="filing_table" responsive="sm" style={{width:"100%"}} hover className={`filings table-hover${filtersVisibility ? ' with-filters' : ''}`} >
            <thead className="responsive-th">
              <tr>
                <th>SR</th>
                <Heading classes="text-left" title="Company" isSortable={sortable && true} />
                <Heading classes="text-inline" title="Filed At" isSortable={sortable && true} />
                <Heading classes="text-inline" title="Fetched At" isSortable={sortable && true} />
                <th className="text-left" style={{paddingLeft:"1%"}}>Form</th>
                
                <th>Filing</th>
              </tr>
            </thead>
            <tbody>
              {filings.map((filing, index) => {
                
                let filingTime = moment(filing.filedAt)
                  .toDate()
                  .toLocaleTimeString("en-US", {
                    timeZone: "America/New_York",
                    hour: "2-digit",
                    minute: "2-digit",
                  });

                return (
                  <tr key={index}>
                    <td>{++index}</td>
                    <td>{filing.companyName}</td>
                    <td className="text-muted text-inline">
                      {queryByFetch &&
                        moment(filing.filedAt.split("T")[0]).format(
                          "YYYY-MM-DD"
                        ) + " "}
                      {filingTime}
                    </td>
                    <td className="text-muted text-inline">
                      {filing.fetchedAtDate
                        ? moment(filing.fetchedAtDate).format("YYYY-MM-DD")
                        : "n/a"}
                    </td>
                    <td>
                      {filing.documentFormatFiles &&
                        filing.documentFormatFiles
                          .filter(
                            (item) =>{
                              return item.type?.toLowerCase().includes("ex") ||
                              item.type === filing.formType
                            })
                          .map((doc, index) => {
                            var isSelected = selections !== undefined ? selections.find(
                              (item) => {
                                if((item.filingId === filing.accessionNo) && (doc.documentId === item.documentId)){
                                  return item;
                                }                                  
                              }) : null;
                              
                            var inventories = catalogue
                              .filter(
                                (item) =>{
                                  if((item.filingId === filing.accessionNo) &&
                                    (item.exhibit === doc.type) && (item.documentId === doc.documentId)){
                                      return item;
                                  }
                                })
                              .map((item) => item.inventory)
                              .flat();
                            inventories = inventories.filter(
                              (item, index, self) =>
                                self.findIndex(
                                  (inventory) => inventory.id === item.id
                                ) === index
                            );
                            
                            var categories = catalogue
                              .filter(
                                (item) =>{
                                  if((item.filingId === filing.accessionNo) &&
                                    (item.exhibit === doc.type) && (item.documentId === doc.documentId)){
                                      return item;
                                  }
                                })
                              .map((item) => item.category)
                              .flat();
                              categories = categories.filter(
                                (item, index, self) =>
                                  self.findIndex(
                                    (inventory) => inventory.id === item.id
                                  ) === index
                              );
                            return (
                              <button
                              key={index}
                              className={`mr-1 roundedEdges line-heigh ${isSelected ? "btn btn-warning btn-sm text-black" : inventories?.length ? "btn btn-outline-deal-style btn-sm" : "link documentClass"}`}
                              onClick={() => {
                                this.showDocument(filing, doc);
                              }}
                            >
                              {doc.type}{" "}
                              {inventories.map((item, index) => (
                                
                                <Badge
                                  variant="dark"
                                  size="sm"
                                  className="ml-1 mr-1"
                                  style={{position: "inherit"}}
                                  key={index}
                                  title={item.name}
                                >
                                  {item.name.match(/\b(\w)/g).join("")}
                                </Badge>
                              ))}

                              {categories.map((item, index) => (                                
                                <Badge
                                  variant="dark"
                                  size="sm"
                                  className="ml-1 mr-1"
                                  style={{position: "inherit"}}
                                  key={index}
                                  title={item.name}
                                >
                                  {abbrivateCategories(item.name)}
                                </Badge>
                              ))}
                            </button>
                            );
                          })}
                    </td>

                    <td>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className="documentClass"
                        href={`https://www.sec.gov/Archives/edgar/data/${
                          filing.cik
                        }/${filing.accessionNo.replace(/-/gi, "")}/${
                          filing.accessionNo
                        }-index.html`}
                      >
                        <span className="material-icons">launch</span>
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <Alert variant="info">
            <h4 className="mb-0">No items to show</h4>
          </Alert>
        )}
        {preview && (
          <FilingPreview
            filing={preview.filing}
            doc={preview.doc}
            btnShow={this.props.btnShow}
            onDocumentClosed={() => this.hideDocument()}
            selections={selections}
            catalogue={catalogue}
            onCatalogueAdd={this.props.onCatalogueAdd}
            onCatalogueRemove={this.props.onCatalogueRemove}
          />
        )}
      </Fragment>
    );
  }
}

FilingList.propTypes = {
  filings: PropTypes.array.isRequired,
  catalogue: PropTypes.array.isRequired,
  selections: PropTypes.array.isRequired,
  onCatalogueAdd: PropTypes.func.isRequired,
  onCatalogueRemove: PropTypes.func.isRequired,
};

export default FilingList;
